app.controller('teacherAppWelcomeCtrl', [
    '$scope', '$rootScope', '$http', '$state', 'teacherAppService', function ($scope, $rootScope, $http, $state, teacherAppService) {
        var vm = this;

        var temporaryConfigNoRealTeacherName = false;

        vm.teacherName = "LÆRER";
        if (!temporaryConfigNoRealTeacherName) {
            var tn = teacherAppService.gameDayInfo.teacherName;
            if (tn != null && tn != "") {
               vm.teacherName = tn.toUpperCase();
            }
        }

        vm.showPlaceHolder = true;

		vm.isPlaying = false;
        vm.playVideo = function() {
            var video = $(".w3video")[0];
            if (vm.showPlaceHolder) {
                vm.showPlaceHolder = false;
                video.play();
                vm.isPlaying = true;
            } else {
                if (vm.isPlaying) {
                    video.pause();
                    vm.isPlaying = false;
                } else {
                    video.play();
                    vm.isPlaying = true;
                }
            }
        }

        vm.next = function() {
        	$state.go('teacherapp.groupstatus');
        }
    }
]);
